import { imageServerConfig } from '../config/imageServer';

/**
 * URL for a short audio clip from the image server.
 * @param audioId - Clip id, optionally namespaced (`adventureId:clipId`)
 */
export function generateAudioUrl(audioId: string): string {
  const baseUrl = imageServerConfig.baseUrl;
  const escapedId = encodeURIComponent(audioId);
  return `${baseUrl}/audio/${escapedId}`;
}
